import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {Menu} from "../../utils/menu/Menu";
import React, {useCallback, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {formatErrors, roleNames, validateEmail} from "../../constants";
import {
  getProfileAction,
  updateProfileAction,
  uploadProfilePhotoAction
} from "../../actions/profileAction";
import {InputProfile} from "../../utils/input/InputProfile";
import {MenuHeader} from "../../utils/menu/MenuHeader";
import {InputAvatar} from "../../utils/inputAvatar/InputAvatar";

const Profile = (props) => {
  const {getProfile} = props;
  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);

  // get profile
  const getProfileInfo = useCallback(() => {
    getProfile().then((data) => {
      setItem(data);
      setForm({
        email: data.email,
        last_name: data.last_name || '',
        first_name: data.first_name || '',
        patronymic_name: data.patronymic_name || '',
        password: ''
      })
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [getProfile]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm({...form, [name]: value});
    setErrors({...errors, [name]: value.trim() === ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.email === '' || validateEmail(form.email) !== true) {
      errs.email = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    props.editProfile(form).then(() => {
      setLoading(false);
      getProfileInfo();
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });

  };

  const handleImageChanged = (photo) => {
    setItem({...item, photo});
  };

  useEffect(() => {
    getProfileInfo();
  }, [getProfileInfo]);

  return <div className="content">
    <Menu />
    <MenuHeader>
      <h2 className="header__title">Профиль</h2>
    </MenuHeader>

    {form && <div className="profile">
      <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <InputAvatar id={item.id} image={item.photo} handleUpdate={props.updateProfilePhoto} handleChange={handleImageChanged}/>
        <h4 className="profile__name">{item.last_name} {item.first_name} {item.patronymic_name}</h4>
        <div className="profile__status">{roleNames[item.role_id - 1]}</div>
        <a href={"mailto:" + item.email} className="profile__email">{item.email}</a>
        <div className="profile__inner">
          <InputProfile type="text"
                        title="Фамилия"
                        name="last_name"
                        placeholder="Введите фамилию"
                        value={form.last_name}
                        error={errors.last_name || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>

          <InputProfile type="text"
                        title="Имя"
                        name="first_name"
                        placeholder="Введите имя"
                        value={form.first_name}
                        error={errors.first_name || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>

          <InputProfile type="text"
                        title="Отчество"
                        name="patronymic_name"
                        placeholder="Введите отчество"
                        value={form.patronymic_name}
                        error={errors.patronymic_name || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>

          <InputProfile type="email"
                        title="Эл. почта"
                        name="email"
                        placeholder="Введите эл. почту"
                        value={form.email}
                        error={errors.email || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>

          <InputProfile type="text"
                        title="Пароль"
                        name="password"
                        placeholder="Введите пароль"
                        value={form.password}
                        error={errors.password || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>

          <button className="profile__btn btn">Сохранить</button>
        </div>
      </form>
    </div>}
  </div>;
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfile() {
      return dispatch(getProfileAction());
    },
    editProfile(data) {
      return dispatch(updateProfileAction(data));
    },
    updateProfilePhoto(id, file) {
      return dispatch(uploadProfilePhotoAction(file));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Profile))
